module.exports = __webpack_public_path__ + "sme_uae_logo-799d637b362e246a3578.png";